import { ActionBadge } from "components/ActionBadge";
import {
  AssetCell,
  AssetLogo,
  AssetInfo,
  AssetSymbol,
  ExecutionCell,
  PriceValue,
  SharesValue,
  TotalCell,
  DateCell,
} from "./RecentTransactions.styles";

const formatCurrency = (value) => {
  if (isNaN(value)) return "$0.00";
  const formattedValue = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(Math.abs(value));
  return value < 0 ? `-${formattedValue}` : formattedValue;
};

export const columns = [
  {
    dataField: "asset",
    text: "Asset",
    props: {
      cell: ({ row }) => {
        const { asset, type } = row.original;
        return (
          <AssetCell>
            <AssetLogo src={asset.imageUrl} alt={asset.symbol} />
            <AssetInfo>
              <AssetSymbol>{asset.symbol}</AssetSymbol>
              <ActionBadge type={type} />
            </AssetInfo>
          </AssetCell>
        );
      },
    },
  },
  {
    dataField: "executionPrice",
    text: "Execution price",
    props: {
      cell: ({ row }) => {
        const { executionPrice, shares } = row.original;
        return (
          <ExecutionCell>
            <PriceValue>{formatCurrency(executionPrice)}</PriceValue>
            <SharesValue>{shares} shares</SharesValue>
          </ExecutionCell>
        );
      },
    },
  },
  {
    dataField: "total",
    text: "Total",
    props: {
      cell: ({ getValue }) => {
        const totalValue = getValue();
        const isPositive = totalValue >= 0;
        return (
          <TotalCell $isPositive={isPositive}>
            {formatCurrency(totalValue)}
          </TotalCell>
        );
      },
    },
  },
  {
    dataField: "date",
    text: "Date",
    props: {
      cell: ({ getValue }) => <DateCell>{getValue()}</DateCell>,
    },
  },
];
